// src/api/userSubastaApi.ts
import client from './client';

export interface UserSubasta {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phoneNumber: string | null;
  palletNumber: number | null;
  aprobadoSubastar: boolean;
  avatarUrl: string | null;
  createdAt: string | null;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export async function listarUsuarios(
  page = 0, size = 30, q = ''
): Promise<PageResponse<UserSubasta>> {
  const res = await client.get('/admin/users-subasta', { params: { page, size, q } });
  return res.data.content;
}

export async function aprobarUsuario(userId: string): Promise<UserSubasta> {
  const res = await client.post(`/admin/users-subasta/${userId}/approve`);
  return res.data.content;
}

export async function revocarUsuario(userId: string): Promise<UserSubasta> {
  const res = await client.post(`/admin/users-subasta/${userId}/revoke`);
  return res.data.content;
}
